import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#5e221d',
          secondary: '#002633',
          background: '#ffffff',
          surface: '#ffffff',
          error: '#DD442C',
          success: '#4CAF50',
        }
      }
    }
  },
  icons: {
    defaultSet: 'mdi'
  }
});
